



































































import Vue from 'vue';
import upgradeVuex from '../vuex/common';
import { FansLevel, Time, Module, SubscribeAccount, ServiceAccount, Pay } from '../models/Fee';
import RiskBox from 'common/components/ui/RiskBox/index.vue';
import accountClient from '../../account/apis';
import PayBox from './PayBox.vue';

export default Vue.extend({
  mixins: [upgradeVuex],
  components: {
    RiskBox,
    PayBox,
  },
  data() {
    return  {
      starYesImg: require('assets/img/star-yes.svg'),
      FansLevel,
      SubscribeAccount,
      Pay,
      ServiceAccount,
      clicked: false,
      showInputPromoCode: false,
      promoCode: null,
      showPayBox: false,
      wxCodeUrl: null,
      orderId: null,
    };
  },
  computed: {
    showAllTips(): boolean {
      return this.upgrade.isAll && (!this.accountState.crmLevel || (this.accountState.crmLevel && this.accountState.isExpired));
    },
    discountFee(): number {
      if (this.upgrade.discount) {
        const fdiscount = JSON.parse(this.upgrade.discount.discount);
        return fdiscount.Fixed.n;
      } else {
        return 0;
      }
    },
  },
  watch: {
    'upgrade.discount'() {
      if (this.upgrade.discount) {
        this.promoCode = this.upgrade.discount.code;
      }
    },
  },
  methods: {
    confirmPay() {
      if (this.checkPayPre()) {
        const tempModules = this.upgrade.isAll ? [Module.Customer, Module.Rule, Module.Mass] : this.upgrade.modules;
        const crmLevelUnit = {accountType: this.account.weixinType, modules: tempModules, followerLevel: this.upgrade.level };
        let discount = null;
        let fee = this.upgrade.fee;
        if (this.upgrade.discount) {
          const fdiscount = JSON.parse(this.upgrade.discount.discount);
          discount = {id: this.upgrade.discount.id, cutFee: fdiscount.Fixed.n};
          fee = fee + fdiscount.Fixed.n;
        }
        accountClient.makeUpgradeOrder({
          after: crmLevelUnit,
          years: this.upgrade.time,
          upgradeFee: fee,
          discount: discount,
          payMethod: this.upgrade.payType}).success((r) => {
          if (this.upgrade.payType === Pay.Wx && r.WxCodeUrl) {
            this.wxCodeUrl = r.WxCodeUrl.url;
            this.orderId = r.WxCodeUrl.orderId;
            this.showPayBox = true;
          } else if (this.upgrade.payType === Pay.AliPay && r.AlipayUrl) {
            this.showPayBox = true;
            this.orderId = r.AlipayUrl.orderId;
            window.open(r.AlipayUrl.url);
          } else {
            this.$Message.error('非法操作，请重试');
          }
        }).error((r) => {
          this.$Message.error('下单错误，请重试');
        });
      }
    },
    checkPayPre() {
      if (!this.upgrade.isAll && this.upgrade.modules.length === 0) {
        this.$Message.warning('请选择服务');
        return false;
      }
      return true;
    },
    confirmPromoCode() {
      if (!this.promoCode || this.promoCode === '') {
        this.$Message.warning('请输入优惠码');
      }
      accountClient.bindDiscount({code: this.promoCode}).success((r) => {
        if (r) {
          this.$store.commit('UPDATE_DISCOUNT', r);
          this.showInputPromoCode = false;
        } else {
          this.$Message.warning('该优惠码无效，请重新输入');
        }
      });
    },
    selectPayType(payType: number) {
      this.$store.commit('UPDATE_PAY_TYPE', payType);
    },
    reduceAll() {
      let fee = 0;
      let modulePrices: any;
      if(this.account.weixinType === 1) {
        modulePrices = ServiceAccount;
      } else {
        modulePrices = SubscribeAccount;
      }
      switch (this.upgrade.level) {
        case FansLevel.Level1:
          fee =  (modulePrices.Level1.Customer + modulePrices.Level1.Rule +  modulePrices.Level1.Mass) - modulePrices.Level1.All;
          break;
        case FansLevel.Level2:
          fee = (modulePrices.Level2.Customer + modulePrices.Level2.Rule +  modulePrices.Level2.Mass) - modulePrices.Level2.All;
          break;
        case FansLevel.Level3:
          fee = (modulePrices.Level3.Customer + modulePrices.Level3.Rule +  modulePrices.Level3.Mass) - modulePrices.Level3.All;
          break;
        default:
          break;
      }
      return fee;
    },
  },
});
